import { useEffect } from "react";

export const IDLE_KEY = "coach_last_activity";
export const IDLE_MS = 30 * 60 * 1000;

export const touchActivity = () => sessionStorage.setItem(IDLE_KEY, String(Date.now()));
export const isIdleExpired = () => {
  const last = Number(sessionStorage.getItem(IDLE_KEY) || 0);
  return !last || Date.now() - last > IDLE_MS;
};

export const useIdleLogout = (active, onExpire) => {
  useEffect(() => {
    if (!active) return undefined;
    touchActivity();
    let last = 0;
    const onActivity = () => {
      const now = Date.now();
      if (now - last > 5000) { last = now; touchActivity(); }
    };
    const events = ["pointerdown", "keydown", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, onActivity, { passive: true }));
    const timer = setInterval(() => { if (isIdleExpired()) onExpire(); }, 30000);
    return () => {
      events.forEach((e) => window.removeEventListener(e, onActivity));
      clearInterval(timer);
    };
  }, [active, onExpire]);
};

export const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => { meta.remove(); };
  }, []);
};
